document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    let priceDiv = document.querySelector(".product__price .price__regular");

    if (!priceDiv) return;

    // Price update function
    function updatePrice(newPrice) {
      priceDiv.textContent = newPrice;
    }

    // Sab pack boxes select karo
    let packBoxes = document.querySelectorAll(".pb-6b5d");

    packBoxes.forEach(function (box) {
      box.addEventListener("click", function () {
        let priceElement = this.querySelector(".pb-1aad.money");
        if (priceElement) {
          let newPrice = priceElement.textContent.trim();
          updatePrice(newPrice);
        }
      });
    });

    // Default me pehle pack ka price set karo
    let defaultPrice = document.querySelector(".pb-6b5d .pb-1aad.money");
    if (defaultPrice) {
      updatePrice(defaultPrice.textContent.trim());
    }
  }, 4000); // 4s wait for widget load
});